import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'


function checkSeatsAndSteeringWheelBadges_a6_c9() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}


function addListeners_a6_c9(frontCheckboxesMap, modalsCheckboxesMap) {

	frontCheckboxesMap['Q8H_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H_A6_C9', this.checked);
		saveStateWithAjax('7HF_A6_C9', false);

		if (this.checked) {
			//If we dont come from the modal
			/*
			const boxesToUncheck = ['7HF_A6_C9']
			boxesToUncheck.forEach(key => {
				frontCheckboxesMap[key].parentElement.classList.remove('is-checked')
				this.checked = false
				saveStateWithAjax(key, false)
				getPackageImages_a6_c9(key, frontCheckboxesMap)
			});	
			*/
			
			/* Clean popup checkboxes */
			jQuery("#Q8H_7HH_A6_C9").addClass("is-checked");
			jQuery("#7HF_A6_C9").removeClass("is-checked");
			jQuery("#Q8H_7HH_A6_C9 .aui-checkbox__input").prop("disabled", false);
			jQuery("#7HF_A6_C9 .aui-checkbox__input").prop("disabled", false);
			//jQuery("#submit_button").prop("disabled", true);			
			/* Clean popup checkboxes */

		} else {
			checkLocks_a6_c9(frontCheckboxesMap)
			saveStateWithAjax('Q8H_A6_C9', false);
			saveStateWithAjax('7HF_A6_C9', false);
		}
		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if ((CarmodelPopUp == 60) || (CarmodelPopUp == 61) || (CarmodelPopUp == 62) || (CarmodelPopUp == 63) || (CarmodelPopUp == 64) || (CarmodelPopUp == 65))  {
			const modal = document.querySelectorAll('.modal_a6_c9')[0]
			if (this.checked) {
				modal.classList.remove("hidden")		
			} else {
				modal.classList.add("hidden")
			}
		}
		getPackageImages_a6_c9('Q8H_A6_C9', frontCheckboxesMap)
		getPackageImages_a6_c9('Q8H_A6_C9', frontCheckboxesMap)
	})

	frontCheckboxesMap['7HF_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('Q8H_A6_C9', false);
		saveStateWithAjax('7HF_A6_C9', this.checked);

		if (this.checked) {
			//If we dont come from the modal
			/*
			const boxesToUncheck = ['7HF_A6_C9']
			boxesToUncheck.forEach(key => {
				frontCheckboxesMap[key].parentElement.classList.remove('is-checked')
				this.checked = false
				saveStateWithAjax(key, false)
				getPackageImages_a6_c9(key, frontCheckboxesMap)
			});	
			*/
			
			/* Clean popup checkboxes */
			jQuery("#Q8H_7HH_A6_C9").removeClass("is-checked");
			jQuery("#7HF_A6_C9").addClass("is-checked");
			jQuery("#Q8H_7HH_A6_C9 .aui-checkbox__input").prop("disabled", false);
			jQuery("#7HF_A6_C9 .aui-checkbox__input").prop("disabled", false);
			//jQuery("#submit_button").prop("disabled", true);			
			/* Clean popup checkboxes */

		} else {
			checkLocks_a6_c9(frontCheckboxesMap)
			saveStateWithAjax('Q8H_A6_C9', false);
			saveStateWithAjax('7HF_A6_C9', false);
		}
		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if ((CarmodelPopUp == 60) || (CarmodelPopUp == 61) || (CarmodelPopUp == 62) || (CarmodelPopUp == 63) || (CarmodelPopUp == 64) || (CarmodelPopUp == 65))  {
			const modal = document.querySelectorAll('.modal_a6_c9')[0]
			if (this.checked) {
				modal.classList.remove("hidden")		
			} else {
				modal.classList.add("hidden")
			}
		}
		getPackageImages_a6_c9('7HF_A6_C9', frontCheckboxesMap)
		getPackageImages_a6_c9('Q8H_A6_C9', frontCheckboxesMap)
	})

	frontCheckboxesMap['0UD_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0UD_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal

		} else {
			checkLocks_a6_c9(frontCheckboxesMap)
		}

		
		getPackageImages_a6_c9('0UD_A6_C9', frontCheckboxesMap)
	})


	frontCheckboxesMap['7TZ_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('7TZ_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal

		} else {
			checkLocks_a6_c9(frontCheckboxesMap)
		}
		getPackageImages_a6_c9('7TZ_A6_C9', frontCheckboxesMap)
	})

	frontCheckboxesMap['FZ9_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('FZ9_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['FZ8_A6_C9'].checked == false) { 
				frontCheckboxesMap['FZ8_A6_C9'].disabled = true
			}
		} else {
			checkLocks_a6_c9(frontCheckboxesMap)
		}
		getPackageImages_a6_c9('FZ9_A6_C9', frontCheckboxesMap)
	})

	frontCheckboxesMap['FZ8_A6_C9'].addEventListener('change', function () {
			checkSubmit(frontCheckboxesMap)
			saveStateWithAjax('FZ8_A6_C9', this.checked);
			if (this.checked) {
				//If we dont come from the modal
				if (frontCheckboxesMap['FZ9_A6_C9'].checked == false) { 
					frontCheckboxesMap['FZ9_A6_C9'].disabled = true
				}
			} else {
				checkLocks_a6_c9(frontCheckboxesMap)
			}
			getPackageImages_a6_c9('FZ8_A6_C9', frontCheckboxesMap)
		})

    frontCheckboxesMap['0TF_A6_C9'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('0TF_A6_C9', this.checked);
		if (this.checked) {
			//If we dont come from the modal
		} else {
			checkLocks_a6_c9(frontCheckboxesMap)
		}
		getPackageImages_a6_c9('0TF_A6_C9', frontCheckboxesMap)
	})


}

/**Controls frontcheckboxes disable */
function checkLocks_a6_c9(frontCheckboxesMap) {
    //DEFINE UNLOCK CONDITIONS	
	const unlockConditionForQ8H_7HH = true
	const unlockConditionForQ8H_7HF = true
	const unlockConditionFor0UD = true
	const unlockConditionFor7TZ = true
	const unlockConditionForFZ8 = !frontCheckboxesMap['FZ9_A6_C9'].checked
	const unlockConditionForFZ9 = !frontCheckboxesMap['FZ8_A6_C9'].checked
	const unlockConditionFor0TF = true
	

	frontCheckboxesMap['Q8H_A6_C9'].disabled = !unlockConditionForQ8H_7HH
	frontCheckboxesMap['7HF_A6_C9'].disabled = !unlockConditionForQ8H_7HF
	frontCheckboxesMap['0UD_A6_C9'].disabled = !unlockConditionFor0UD
	frontCheckboxesMap['7TZ_A6_C9'].disabled = !unlockConditionFor7TZ
	frontCheckboxesMap['FZ8_A6_C9'].disabled = !unlockConditionForFZ8
	frontCheckboxesMap['FZ9_A6_C9'].disabled = !unlockConditionForFZ9
	frontCheckboxesMap['0TF_A6_C9'].disabled = !unlockConditionFor0TF
}


/**Gets images for all packages depending on selected packages */

function getImages_a6_c9(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_a6_c9(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_a6_c9(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}


export { addListeners_a6_c9, saveStateWithAjax, checkLocks_a6_c9, getImages_a6_c9, getPackageImages_a6_c9, checkSeatsAndSteeringWheelBadges_a6_c9}

